export const INT32_MAX = 2147483647;
export const INT32_MIN = -2147483648;

export const INT64_IEEEE754_MAX = 9007199254740991;
export const INT64_IEEEE754_MIN = -9007199254740992;
